import { render, staticRenderFns } from "./AlignmentSettings.vue?vue&type=template&id=65e77d89&scoped=true&"
import script from "./AlignmentSettings.vue?vue&type=script&lang=js&"
export * from "./AlignmentSettings.vue?vue&type=script&lang=js&"
import style0 from "./AlignmentSettings.vue?vue&type=style&index=0&id=65e77d89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e77d89",
  null
  
)

component.options.__file = "AlignmentSettings.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardText,
  VContainer,
  VFlex,
  VLayout,
  VRadio,
  VRadioGroup,
  VSubheader,
})
